import { useState } from "react";
import { speak, stopSpeaking } from "@/lib/buddy";
import { tone, NOTE } from "@/lib/babySound";
import { ANIMALS } from "./AnimalSounds";

export const Peekaboo = ({ voice }) => {
  const [open, setOpen] = useState(false);
  const [a, setA] = useState(ANIMALS[0]);
  const tap = () => {
    if (open) { setOpen(false); setTimeout(() => setA(ANIMALS[Math.floor(Math.random() * ANIMALS.length)]), 750); return; }
    setOpen(true);
    tone(NOTE.C5, 0.2, { vol: 0.15 }); tone(NOTE.G5, 0.4, { vol: 0.15, at: 0.15 });
    stopSpeaking(); speak(`Peekaboo! I see you, ${a.en.toLowerCase()}!`, voice, 0.9).catch(() => {});
  };
  return (
    <button onPointerDown={tap} className="absolute inset-0 flex items-center justify-center bg-[#FFF4E8] overflow-hidden" data-testid="game-peekaboo" aria-label="Peekaboo">
      <span className={`flex flex-col items-center transition-transform duration-500 ${open ? "scale-100" : "scale-75"}`}>
        <a.Icon className="w-56 h-56" style={{ color: a.color }} strokeWidth={1.4} />
        <span className="font-display text-4xl text-[#2C4A3E] mt-2">{open ? "Peekaboo!" : ""}</span>
      </span>
      <span className="absolute inset-x-[10%] top-[12%] bottom-[12%] rounded-[3rem] transition-transform duration-700 ease-in-out flex items-end justify-center pb-10"
        style={{ transform: open ? "translateY(140%)" : "translateY(0)", background: "repeating-linear-gradient(45deg,#6BB3E0,#6BB3E0 30px,#8EC5EA 30px,#8EC5EA 60px)" }} data-testid="peekaboo-blanket">
        <span className="font-display text-3xl text-white">Where is it?</span>
      </span>
    </button>
  );
};
